import { defineStore } from 'pinia'
import { useCreateForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useApprovedFirmwaresStore = defineStore('approvedFirmwares', {
  state: () => ({
    data: undefined,
  }),
  getters: {
    getApprovedFirmwares: (state) => state.data?.data,
  },
  actions: {
    async indexApprovedFirmwares(params = {}) {
      try {
        let defaultParams = {};
        const response = await axios.get('approved-firmwares', {params: {...defaultParams, ...params}});
        this.data = response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async createApprovedFirmware(params = {}) {
      try {
        const response = await axios.get('approved-firmwares/create', {params});
        return useCreateForm(`approved-firmwares`, {...response.data});
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showApprovedFirmware(approvedFirmwareId, params = {}) {
      try {
        const response = await axios.get(`approved-firmwares/${ approvedFirmwareId }`, {params});
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editApprovedFirmware(approvedFirmwareId, params = {}) {
      try {
        const response = await axios.get(`approved-firmwares/${ approvedFirmwareId }/edit`, {params});
        return useCreateForm(`approved-firmwares/${ approvedFirmwareId }`, {...response.data, _method: 'PUT'});
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteApprovedFirmware(approvedFirmwareId, params = {}) {
      try {
        const response = await axios.delete(`approved-firmwares/${ approvedFirmwareId }`, {params});
        toasteventbus.emit('add', {
          summary: 'Approved Firmware Deleted',
          detail: `Approved Firmware has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
